<template>
    <div class="card" v-if="product_detail.metas && product_detail.metas.change_ownership_request">
        <div class="card-body">
            <h3>Change ownership request</h3>
            <p>
                <em
                    >Request has been made to change the ownership of the product to [<span class="text-primary">{{
                        product_detail.metas.change_ownership_request
                    }}</span
                    >].
                </em>
            </p>
            <button class="btn btn-secondary with-white-border px-5 btn-rounded" @click.prevent="approve()">APPROVE</button>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';

export default {
    props: ['product_detail'],
    methods: {
        async approve() {
            this.spinner(true);
            const url = `${Env.baseUrl}/v2/superadmin/reg-product/approve-ownership`;
            return AuthApis.postApi(url, {
                product_id: this.product_detail.id
            })
                .then(async (res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: res.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                })
                .catch((err) => {
                    this.spinner(false);
                    console.log(err);
                    this.$toasted.global.error({
                        message: err.response.data.message
                    });
                });
        }
    }
};
</script>
